module.exports = __webpack_public_path__ + "assets/422feeb688262b83f13c05ab512ccf6d.png";